import { Flex, FormInstance } from "antd";
import * as dc from "@/components/layout/list/defaultType";
import { DataColumnField, DataColumnRecord } from "../input/inputType";
import { RefObject } from "react";
import { runFormFunction } from "../input/inputFunction";
import { Debug } from "@/util/debug";
import { checkEmpty } from "@/util/stringutil";
import { enLocale, koLocale } from "@/i18n/routing";
import Icon from "@/components/common/icon/icon";
export const beaninfoNameCols = (
  form: RefObject<FormInstance<any> | undefined> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  locale: string | undefined,
  detail?: boolean,
): DataColumnRecord => {
  return {
    store_link_read: {
      ...dc.storeLink,
      fieldId: "store_link",
      label: "store_link",
      labelClassName: dc.strongLabelClassName,
      inputClassName: "pl-[0.6rem]",
      display: "notNull",
      edit: { display: false },
    },
    store_name_locale: {
      ...dc.inputFull,
      labelClassName: dc.strongLabelClassName,
      itemClassName: locale !== enLocale ? undefined : "hidden",
    },
    store_name: {
      ...dc.inputFull,
      labelClassName: dc.strongLabelClassName,
      itemClassName: locale !== enLocale ? "hidden" : undefined,
    },
    blending_name_locale: {
      ...dc.inputFull,
      labelClassName: dc.strongLabelClassName,
      itemClassName: locale !== enLocale ? undefined : "hidden",
    },
    blending_name: {
      ...dc.inputFull,
      labelClassName: dc.strongLabelClassName,
      itemClassName: locale !== enLocale ? "hidden" : undefined,
    },
    blending_result_date: {
      labelClassName: dc.strongLabelClassName,
      read: { display: "notNull", displayCheckIds: ["blending_result_date"] },
      fieldId: {
        blending_result_date: {
          ...dc.date,
          dateProp: { nowButton: false },
          disabled: true,
          noItem: false,
          // update: { disabled: true },
        },
        brewing_date_term: {
          ...dc.number,
          inputClassName: "text-last",
          unitPrev: "+",
          unit: { element: "day_unit", transition: true },

          noItem: false,
          disabled: true,
          tooltip: "brewing_date_term",
        },
      },
    },
    cupnote_date: {
      ...dc.date,
      itemClassName: "hidden",
      noItem: false,
    },

    blending_single_origin: {
      ...dc.use,
      label: "single_origin_label",
      read: { display: false },
      //disabled: true,
    },

    ...beaninfoSelectList(form, formFunction, locale, detail),
  };
};
export const beaninfoSelectList = (
  form: RefObject<FormInstance<any> | undefined> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  locale?: string,
  detail?: boolean,
): DataColumnRecord => {
  return {
    blending_country_map: {
      ...dc.geoMapCountryChart("blending_country_list", detail ? "true" : undefined),
    },
    blending_country_list: {
      ...dc.geoMapCountryList(formFunction, "blending_country_map", locale, detail),
      itemClassName: "blending_info",
      onChange: (e) => {
        //Debug(e);
        const setValues: Record<string, any> = {};
        const blending_country_code = e && e.value ? (e.value instanceof Array && e.value.length === 1 ? e.value[0] : e.value) : undefined;
        form?.current?.setFieldsValue({ blending_country_code });
        setTimeout(() => {
          runFormFunction(formFunction, ["blending_region_seq", "blending_farm_seq"], "changeLoad");
        }, dc.setTimeoutShort);
      },
    },
    blending_country_code: {
      ...dc.coffee_country,
      label: "country_label",
      itemClassName: "hidden",
      noItem: false,
      disabled: true,
      readInput: true,
      readInputDisabled: true,
      inputType: "selectSearch",
    },
    blending_country_map_guide: {
      ...dc.guideDefault,
      fixedValue: "country_map_guide",
      display: "notNull",
      displayCheckIds: ["blending_country_list"],
      edit: { display: false },
    },
    blending_region_seq: {
      ...dc.selectSearch,
      itemClassName: "blending_info",
      inputClassName: dc.inputCountryClassName,
      selectPropOption: { reloadButton: true },
      selectChangeLoad: "blending_farm_seq",
      inputDirect: { target: "blending_region_etc", query: ".blending_region_etc_item" },
      dataUrl: "/api/code/region",
      selectProp: { mode: "multiple" },
      noItem: false,
      readInput: true,
      readInputDisabled: true,
      dataProp: {
        fixedParam: { is_parent: false },
        valueParam: { region_country: "blending_country_code" },
        requiredParam: ["region_country"],
        userAuth: false,
      },
      dataLabel: {
        value: "region_seq",
        label: [
          { field: "region_name_locale", subs: "region_nick_locale" },
          { field: "region_name", subs: "region_nick" },
        ],
      },
      read: {
        display: detail ? "notNull" : undefined,
        disabled: true,
        dataLabel: {
          value: "region_seq",
          label:
            locale === enLocale
              ? "region_name"
              : [
                  { field: "region_name_locale", subs: "region_nick_locale" },
                  { field: "region_name", subs: "region_nick" },
                ],
        },
      },
    },
    blending_region_etc: {
      ...dc.inputFull,
      itemClassName: "blending_region_etc_item blending_info",
      minLength: 3,
      maxLength: 300,
      showCount: true,
      label: "blank",
      labelClassName: dc.mobileHidden,
      placeholder: "blending_region_seq",
      read: { display: detail ? "notNull" : undefined, disabled: true },
    },
    blending_farm_seq: {
      ...dc.selectSearch,
      itemClassName: "blending_info",
      inputClassName: dc.inputCountryClassName,
      inputDirect: { target: "blending_farm_etc", query: ".blending_farm_etc_item" },
      dataUrl: "/api/code/farm",
      selectProp: { mode: "multiple" },
      noItem: false,
      readInput: true,
      readInputDisabled: true,
      dataProp: {
        valueParam: { region_country: "blending_country_code", farm_region_seq: "blending_region_seq" },
        requiredParam: ["region_country"],
        userAuth: false,
      },
      dataLabel: {
        value: "farm_seq",
        label: ["farm_name_locale", "farm_name"],
        labelSort: false,
      },
      read: { display: detail ? "notNull" : undefined, disabled: true },
    },
    blending_farm_etc: {
      ...dc.inputFull,
      itemClassName: "blending_farm_etc_item blending_info",
      minLength: 3,
      maxLength: 300,
      showCount: true,
      label: "blank",
      labelClassName: dc.mobileHidden,
      placeholder: "blending_farm_seq",
      read: { display: detail ? "notNull" : undefined, disabled: true },
    },
    blending_process_list: {
      ...dc.process,
      itemClassName: "blending_info",
      noItem: false,
      readInput: true,
      readInputDisabled: true,
      label: "process_label",
      selectProp: { mode: "multiple" },
      inputDirect: { target: "blending_process_etc", query: ".blending_process_etc_item" },
      read: { display: detail ? "notNull" : undefined, disabled: true },
    },
    blending_process_etc: {
      ...dc.inputFull,
      itemClassName: "blending_process_etc_item blending_info",
      minLength: 3,
      maxLength: 300,
      showCount: true,
      label: "blank",
      labelClassName: dc.mobileHidden,
      placeholder: "process_label",
    },
    blending_variety_list: {
      ...dc.varietyMulti,
      selectProp: { mode: "multiple" },
      itemClassName: "blending_info",
      noItem: false,
      readInput: true,
      readInputDisabled: true,
      inputDirect: { target: "blending_variety_etc", query: ".blending_variety_etc_item" },
      read: {
        display: detail ? "notNull" : undefined,
        onClick: dc.clickDefault(
          (e: any) => {
            //alert(e);
          },
          () => {
            //alert("해당 품종에 대한 정보가 없습니다.");
          },
        ),
        disabled: true,
      },
    },
    blending_variety_etc: {
      ...dc.inputFull,
      itemClassName: "blending_variety_etc_item blending_info",
      minLength: 3,
      maxLength: 300,
      showCount: true,
      label: "blank",
      labelClassName: dc.mobileHidden,
      placeholder: "blending_variety_list",
    },
    blending_grade_list: {
      ...dc.grade,
      itemClassName: "blending_info",
      noItem: false,
      readInput: true,
      readInputDisabled: true,
      selectProp: { mode: "multiple" },
      read: { display: detail ? "notNull" : undefined, disabled: true },
    },
    blending_grade_detail_list: {
      ...dc.gradeDetail,
      itemClassName: "blending_info",
      noItem: false,
      readInput: true,
      readInputDisabled: true,
      selectProp: { mode: "multiple" },
      read: { display: detail ? "notNull" : undefined, disabled: true },
    },
  };
};
export const getBeaninfoList = (data: any, etcMerge?: boolean) => {
  const greenbean_country_list: string[] = [];
  const greenbean_variety_list: string[] = [];
  const greenbean_grade_list: string[] = [];
  const greenbean_grade_detail_list: string[] = [];
  const greenbean_process_list: string[] = [];
  const greenbean_variety_etc: string[] = [];
  const greenbean_process_etc: string[] = [];
  const greenbean_region_list: string[] = [];
  const greenbean_region_etc: string[] = [];
  const greenbean_farm_list: string[] = [];
  const greenbean_farm_etc: string[] = [];
  // const moisture_values: Record<string, number> = {};
  if (data && data instanceof Array) {
    data.forEach((temp_data) => {
      const temp_greenbean_country_code = temp_data["greenbean_country_code"];
      const temp_greenbean_variety_list = temp_data["greenbean_variety_list"];
      const temp_greenbean_grade = temp_data["greenbean_grade"];
      const temp_greenbean_grade_detail = temp_data["greenbean_grade_detail"];
      const temp_greenbean_process = temp_data["greenbean_process"];
      const temp_greenbean_variety_etc = temp_data["greenbean_variety_etc"];
      const temp_greenbean_process_etc = temp_data["greenbean_process_etc"];
      const temp_greenbean_region = temp_data["greenbean_region_seq"];
      const temp_greenbean_region_etc = temp_data["greenbean_region_etc"];
      const temp_greenbean_farm = temp_data["greenbean_farm_seq"];
      const temp_greenbean_farm_etc = temp_data["greenbean_farm_etc"];

      if (!checkEmpty(temp_greenbean_country_code) && !greenbean_country_list.includes(temp_greenbean_country_code)) {
        greenbean_country_list.push(temp_greenbean_country_code);
      }

      if (!checkEmpty(temp_greenbean_variety_list) && typeof temp_greenbean_variety_list === "string") {
        const temp_arr = temp_greenbean_variety_list.split(",");
        temp_arr.forEach((temp) => {
          if (!greenbean_variety_list.includes(temp)) {
            greenbean_variety_list.push(temp);
          }
        });
      }

      if (!checkEmpty(temp_greenbean_grade) && typeof temp_greenbean_grade === "string") {
        const temp_arr = temp_greenbean_grade.split(",");
        temp_arr.forEach((temp) => {
          if (!greenbean_grade_list.includes(temp)) {
            greenbean_grade_list.push(temp);
          }
        });
      }

      if (!checkEmpty(temp_greenbean_grade_detail) && typeof temp_greenbean_grade_detail === "string") {
        const temp_arr = temp_greenbean_grade_detail.split(",");
        temp_arr.forEach((temp) => {
          if (!greenbean_grade_detail_list.includes(temp)) {
            greenbean_grade_detail_list.push(temp);
          }
        });
      }

      if (!checkEmpty(temp_greenbean_process) && typeof temp_greenbean_process === "string") {
        const temp_arr = temp_greenbean_process.split(",");
        temp_arr.forEach((temp) => {
          if (!greenbean_process_list.includes(temp)) {
            greenbean_process_list.push(temp);
          }
        });
      }

      if (!checkEmpty(temp_greenbean_variety_etc)) {
        greenbean_variety_etc.push(temp_greenbean_variety_etc);
      }
      if (!checkEmpty(temp_greenbean_process_etc)) {
        greenbean_process_etc.push(temp_greenbean_process_etc);
      }

      if (!checkEmpty(temp_greenbean_region) && !greenbean_region_list.includes(temp_greenbean_region)) {
        greenbean_region_list.push(temp_greenbean_region);
      }
      if (!checkEmpty(temp_greenbean_region_etc) && !greenbean_region_etc.includes(temp_greenbean_region_etc)) {
        greenbean_region_etc.push(temp_greenbean_region_etc);
      }
      if (!checkEmpty(temp_greenbean_farm) && !greenbean_region_list.includes(temp_greenbean_farm)) {
        greenbean_region_list.push(temp_greenbean_farm);
      }
      if (!checkEmpty(temp_greenbean_farm_etc) && !greenbean_farm_etc.includes(temp_greenbean_farm_etc)) {
        greenbean_farm_etc.push(temp_greenbean_farm_etc);
      }
    });
  }
  const greenbean_country_code = greenbean_country_list.length == 1 ? greenbean_country_list[0] : undefined;
  const check_country_single = !checkEmpty(greenbean_country_code);
  if (etcMerge) {
    if (!checkEmpty(greenbean_variety_etc)) {
      greenbean_variety_list.push(...greenbean_variety_etc);
    }
    if (!checkEmpty(greenbean_process_etc)) {
      greenbean_process_list.push(...greenbean_process_etc);
    }
    if (!checkEmpty(greenbean_region_etc)) {
      greenbean_region_list.push(...greenbean_region_etc);
    }
    if (!checkEmpty(greenbean_farm_etc)) {
      greenbean_farm_list.push(...greenbean_farm_etc);
    }
    return {
      greenbean_country_list,
      greenbean_country_code,
      greenbean_variety_list,
      greenbean_grade_list,
      greenbean_grade_detail_list,
      greenbean_process_list,
      greenbean_region_list:
        check_country_single && greenbean_region_list && greenbean_region_list.length == 1 ? greenbean_region_list[0] : undefined,
      greenbean_farm_list:
        check_country_single && greenbean_farm_list && greenbean_farm_list.length === 1 ? greenbean_farm_list[0] : undefined,
    };
  } else {
    if (!checkEmpty(greenbean_variety_etc)) {
      greenbean_variety_list.push(dc.input_direct);
    }
    if (!checkEmpty(greenbean_process_etc)) {
      greenbean_process_list.push(dc.input_direct);
    }
    if (!checkEmpty(greenbean_region_etc)) {
      greenbean_region_list.push(dc.input_direct);
    }
    if (!checkEmpty(greenbean_farm_etc)) {
      greenbean_farm_list.push(dc.input_direct);
    }
    return {
      greenbean_country_list,
      greenbean_country_code,
      greenbean_variety_list,
      greenbean_grade_list,
      greenbean_grade_detail_list,
      greenbean_process_list,
      greenbean_region_list:
        check_country_single && greenbean_region_list && greenbean_region_list.length == 1 ? greenbean_region_list[0] : undefined,
      greenbean_farm_list:
        check_country_single && greenbean_farm_list && greenbean_farm_list.length === 1 ? greenbean_farm_list[0] : undefined,
      greenbean_variety_etc: !checkEmpty(greenbean_variety_etc) ? greenbean_variety_etc.join(",") : undefined,
      greenbean_process_etc: !checkEmpty(greenbean_process_etc) ? greenbean_process_etc.join(",") : undefined,
      greenbean_region_etc: check_country_single && !checkEmpty(greenbean_region_etc) ? greenbean_region_etc.join(",") : undefined,
      greenbean_farm_etc: check_country_single && !checkEmpty(greenbean_farm_etc) ? greenbean_farm_etc.join(",") : undefined,
    };
  }
};
export const beanInfoChange = (
  form: FormInstance<any> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  data: any,
) => {
  const blending_info_use = form?.getFieldValue("blending_info_use");
  Debug("beaninfoGreenbeanCol blending_info_use : " + blending_info_use);
  let setValues: any = undefined;
  let country_code_check = false;
  if (blending_info_use !== undefined && blending_info_use === 0) {
    const getValues = form?.getFieldsValue([
      "blending_country_list",
      "blending_region_seq",
      "blending_region_seq",
      "blending_farm_seq",
      "blending_variety_list",
      "blending_grade_list",
      "blending_grade_detail_list",
      "blending_process_list",
    ]);
    if (getValues["blending_country_list"] !== undefined) {
      if (getValues["blending_country_list"].length > 1) {
        setValues = {
          blending_country_code: getValues["blending_country_list"][0],
        };
      }
    }
    country_code_check = true;
  } else {
    const info = getBeaninfoList(data, true);
    Debug("beaninfoGreenbeanCol info", info);
    setValues = {
      blending_country_list: info.greenbean_country_list,
      blending_country_code: info.greenbean_country_code,
      blending_region_seq: info.greenbean_region_list,
      blending_farm_seq: info.greenbean_farm_list,
      blending_variety_list: info.greenbean_variety_list,
      blending_grade_list: info.greenbean_grade_list,
      blending_grade_detail_list: info.greenbean_grade_detail_list,
      blending_process_list: info.greenbean_process_list,
    };
    if (!checkEmpty(info.greenbean_country_code)) {
      country_code_check = true;
    }
  }
  if (setValues && form) {
    form.setFieldsValue(setValues);
  }

  if (country_code_check) {
    runFormFunction(formFunction, ["blending_region_seq", "blending_farm_seq"], "changeLoad");
  }

  setTimeout(() => {
    Debug("beaninfoGreenbeanCol setValues", setValues, country_code_check);
    if (setValues && Object.keys(setValues)) {
      Object.keys(setValues).forEach((key) => {
        Debug("beaninfoGreenbeanCol setValues key", key, setValues[key]);
        if (checkEmpty(setValues[key])) {
          Debug("beaninfoGreenbeanCol setValues setItemDisplay false", key);
          runFormFunction(formFunction, key, "setItemDisplay", false);
        }
      });
    }
    if (!checkEmpty(setValues.blending_country_code)) {
      runFormFunction(formFunction, "blending_country_map", "setSelectCountry", [setValues.blending_country_code]);
      setTimeout(() => {
        runFormFunction(formFunction, "blending_country_map", "setSelectCountry", [setValues.blending_country_code]);
      }, dc.setTimeoutDelay * 3);
    }
  }, dc.setTimeoutDelay);
};
export const beaninfoGreenbeanCol = (
  form: RefObject<FormInstance<any> | undefined> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  locale: string | undefined,
): DataColumnField => {
  return {
    ...dc.select,
    itemClassName: "hidden",
    dataValueList: ["greenbean_list"],
    dataLabel: {
      value: "rownum",
      label: [
        "rownum",
        "greenbean_order",
        locale === enLocale
          ? { field: "greenbean_name", subs: "roasting_nick" }
          : { field: "greenbean_name_locale", subs: "roasting_nick_locale" },
      ],
    },
    noItem: false,
    disabled: true,
    readInput: true,
    readInputDisabled: true,
    variant: "outlined",
    dataProp: {
      load: (data, value_data, field, index, change) => {
        Debug("beaninfoGreenbeanCol", { data, value_data, field, index, change });
        if (form?.current && formFunction) {
          beanInfoChange(form.current, formFunction, data);
        } else {
          Debug("beaninfoGreenbeanCol form formFunction is null");
        }
      },
    },
  };
};
export const beaninfoGreenbeanList = (locale: string | undefined, detail?: boolean): DataColumnField => {
  return {
    display: "true",
    label: "blank",
    labelUse: false,
    valueStyle: { gridColumn: "1 / span 2" },
    subList: { target: "greenbean_list", labelField: "COLUMN_NAME" },
    subListKeys: ["greenbean_order"],
    labelClassName: dc.mobileHidden,
    valueClassName: "flex-col before_hidden",
    fieldId: {
      div_item: {
        inputType: "display",
        valueClassName: "itemDiv",
        flexClassName: "w-full itemDiv",
        display: [{ blending_greenbean_list_show: 1 }, { blending_single_origin: 0 }],
        // displayCheckIds: [
        //   "greenbean_name_locale",
        //   "greenbean_name",
        //   "greenbean_altitude_min",
        //   "greenbean_altitude_max",
        //   "greenbean_harvest_min",
        //   "greenbean_harvest_max",
        //   "blending_percent",
        //   "greenbean_mass",
        //   "greenbean_moisture_min",
        //   "greenbean_moisture_max",
        //   "greenbean_density_min",
        //   "greenbean_density_max",
        // ],
        saveData: false,
      },
      blending_greenbean_main: {
        display: "false",
        displayCheckIds: ["blending_single_origin"],
        flexClassName: "w-full",
        fieldId: {
          greenbean_name_sub: {
            display: "notNull",
            displayCheckIds: undefined,
            displayCheckIndexIds: ["greenbean_name_locale", "greenbean_name"],
            flexClassName: "w-full",
            fieldId: {
              greenbean_name_locale: {
                ...dc.inputFull,
                display: locale !== enLocale,
              },
              greenbean_name: {
                ...dc.inputFull,
                display: locale === enLocale,
              },
            },
          },
        },
      },
      blending_greenbean_sub0: {
        display: ["notNull", { blending_single_origin: false }],
        displayCheckIds: ["blending_percent", "greenbean_mass"],
        flexClassName: "ml-0 mt-2 flex-wrap",
        valueClassName: "flex-col lg:flex-row mobile_multi",
        fieldId: {
          blending_greenbean_sub0_1: {
            flexClassName: "flex-row",
            fieldId: {
              blending_percent: {
                ...dc.percent,
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                // variant: "outlined",
                display: ["notNull", { blending_single_origin: "false" }],
                displayCheckIds: undefined,
                displayCheckIndexIds: ["blending_percent"],
              },
              greenbean_mass: {
                ...dc.mass,
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                // variant: "outlined",
                display: ["notNull", { blending_single_origin: "false" }],
                displayCheckIds: undefined,
                displayCheckIndexIds: ["greenbean_mass"],
              },
            },
          },
          blending_greenbean_sub0_2: {
            flexClassName: "flex-row",
            fieldId: {
              greenbean_variety_list_show: {
                ...dc.varietyMulti,
                selectProp: { mode: "multiple" },
              },
            },
          },
        },
      },
      blending_greenbean_sub1: {
        flexClassName: "ml-0 mt-2 flex-wrap",
        display: "false",
        displayCheckIds: ["blending_single_origin"],
        valueClassName: "flex-col lg:flex-row mobile_multi",
        fieldId: {
          blending_greenbean_sub1_1: {
            flexClassName: "flex-row",
            fieldId: {
              greenbean_country_code: {
                ...dc.coffee_country,
                inputClassName: dc.greenbeanMinMaxWidth,
                variant: "outlined",
              },
              greenbean_process: {
                ...dc.process,
                inputClassName: dc.greenbeanMinMaxWidth,
                variant: "outlined",
              },
            },
          },
          blending_greenbean_sub1_2: {
            flexClassName: "ml-0 mt-2 md:ml-2 md:mt-0",
            fieldId: {
              greenbean_grade: {
                ...dc.grade,
                inputClassName: dc.greenbeanMinMaxWidth,
                variant: "outlined",
              },
              greenbean_grade_detail: {
                ...dc.gradeDetail,
                inputClassName: dc.greenbeanMinMaxWidth,
                variant: "outlined",
              },
            },
          },
        },
      },
      blending_greenbean_sub2: {
        flexClassName: "ml-0 mt-2 flex-wrap",
        display: "notNull",
        displayCheckIndexIds: ["greenbean_altitude_min", "greenbean_altitude_max", "greenbean_harvest_min", "greenbean_harvest_max"],
        fieldId: {
          blending_greenbean_sub2_1: {
            flexClassName: "flex-row",
            fieldId: {
              greenbean_altitude_min: {
                ...dc.altitude,
                variant: "outlined",
                tooltip: "greenbean_altitude_min",
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                //clearProp: { clearButton: true },
              },
              greenbean_altitude_max: {
                ...dc.altitude,
                variant: "outlined",
                tooltip: "greenbean_altitude_max",
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                // read: { display: ["notNull", { greenbean_altitude_min: "notEquals" }], displayCheckIds: undefined },
              },
            },
          },
          blending_greenbean_sub2_2: {
            flexClassName: "ml-0 mt-2 md:ml-2 md:mt-0",
            display: "notNull",
            displayCheckIndexIds: ["greenbean_harvest_min", "greenbean_harvest_max"],
            fieldId: {
              greenbean_harvest_min: {
                ...dc.monthSelectFn(locale),
                variant: "outlined",
                tooltip: "greenbean_harvest_min",
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
              },
              greenbean_harvest_max: {
                ...dc.monthSelectFn(locale),
                variant: "outlined",
                tooltip: "greenbean_harvest_max",
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
              },
            },
          },
        },
      },
      blending_greenbean_sub3: {
        flexClassName: "ml-0 mt-2 flex-wrap",
        display: "notNull",
        displayCheckIndexIds: ["greenbean_moisture_min", "greenbean_moisture_max", "greenbean_density_min", "greenbean_density_max"],
        fieldId: {
          blending_greenbean_sub3_1: {
            flexClassName: "flex-row",
            fieldId: {
              greenbean_moisture_min: {
                ...dc.moisture,
                variant: "outlined",
                tooltip: "greenbean_moisture_min",
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
              },
              greenbean_moisture_max: {
                ...dc.moisture,
                variant: "outlined",
                tooltip: "greenbean_moisture_max",
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
              },
            },
          },
          blending_greenbean_sub3_2: {
            flexClassName: "ml-0 mt-2 md:ml-2 md:mt-0",
            display: "notNull",
            displayCheckIndexIds: ["greenbean_density_min", "greenbean_density_max"],
            fieldId: {
              greenbean_density_min: {
                ...dc.density,
                variant: "outlined",
                tooltip: "greenbean_density_min",
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
              },
              greenbean_density_max: {
                ...dc.density,
                variant: "outlined",
                tooltip: "greenbean_density_max",
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                // read: { display: ["notNull", { greenbean_density_min: "notEquals" }], displayCheckIds: undefined },
              },
            },
          },
        },
      },
      blending_greenbean_sub4: {
        flexClassName: "ml-0 mt-2 flex-wrap",
        display: "notNull",
        displayCheckIndexIds: ["roasting_loss", "roasting_organic_loss"],
        fieldId: {
          blending_greenbean_sub4_1: {
            flexClassName: "flex-row",
            display: "notNull",
            displayCheckIndexIds: ["roasting_loss", "roasting_organic_loss"],
            fieldId: {
              roasting_loss: {
                ...dc.lossRate,
                variant: "outlined",
                tooltip: "loss_rate",
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                displayCheckIndexIds: undefined,
              },
              roasting_organic_loss: {
                ...dc.lossRate,
                variant: "outlined",
                tooltip: "organic_loss",
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                displayCheckIndexIds: undefined,
                // read: { display: ["notNull", { greenbean_density_min: "notEquals" }], displayCheckIds: undefined },
              },
            },
          },
        },
      },
    },
  };
};
export const beaninfoLossCols: DataColumnRecord = {
  status_explain: {
    label: "blank",
    labelClassName: dc.mobileHidden,
    read: { display: "notNull", displayCheckIds: ["blending_total_mass", "blending_loss", "blending_organic_loss"] },
    fieldId: {
      explain_mass: {
        ...dc.mass,
        inputClassName: dc.inputNumberClassName,
        readOnly: true,
        disabled: true,
        variant: "borderless",
        read: { display: "notNull", displayCheckIds: ["blending_total_mass"] },
      },
      explain_loss: {
        ...dc.percent,
        readOnly: true,
        disabled: true,
        variant: "borderless",
        placeholder: "loss_rate",
        read: { display: "notNull", displayCheckIds: ["blending_loss"] },
      },
      explain_organic_loss: {
        ...dc.percent,
        inputClassName: "w-[8rem] text-last",
        readOnly: true,
        disabled: true,
        variant: "borderless",
        placeholder: "organic_loss",
        read: { display: "notNull", displayCheckIds: ["blending_organic_loss"] },
      },
    },
  },

  blending_calc: {
    labelClassName: dc.strongLabelClassName,
    read: { display: "notNull", displayCheckIds: ["blending_total_mass", "blending_loss", "blending_organic_loss"] },
    fieldId: {
      blending_total_mass: {
        ...dc.mass,
        inputClassName: dc.inputNumberClassName,
        disabled: true,
        readOnly: true,
        variant: "borderless",
        read: { display: "notNull", displayCheckIds: undefined },
      },
      blending_loss: { ...dc.lossRate, tooltip: "loss_rate", read: { display: "notNull", displayCheckIds: undefined } }, //, variant: "borderless"
      blending_organic_loss: {
        ...dc.lossRate,
        inputClassName: "w-[8rem] text-last",
        placeholder: "organic_loss",
        tooltip: "organic_loss",
        read: { display: "notNull", displayCheckIds: undefined },
      }, //, variant: "borderless"
    },
  },
};
